import "../.././styles/Constitution.css";

function ArticleSeven() {
    return(
        <>
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>VII. COMMITTEES</h3>
                    <h5>7.1 Committees</h5>
                    <ol type="a">
                        <li><p>
                            <b>Executive Committee - </b>The Executive Committee will take a lead role in managing the
                            affairs of the corporation and is comprised of the Officers of the corporation.
                        </p></li>
                        <ol type="1" className="indent">
                            <li><p>
                                Members of the Executive Committee shall meet quarterly or at least four times per
                                calendar year. The President of the corporation may call a special or emergency
                                meeting of the Executive Committee, as it deems necessary.
                            </p></li>
                            <li><p>
                                At each meeting, the Executive Committee, through the coordinated efforts of the
                                President and Recording Secretary shall submit a complete report of all decisions
                                and actions taken by it since the last meeting of the Governing Board.
                            </p></li>
                            <li><p>
                                Any vacated position, as a result of resignation, disqualification, and/or removal
                                may be filled at any time by the Governing Board.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Standing Committees – </b>Standing Committees shall have continued responsibility and will
                            comprised of the following:
                        </p></li>
                        <ol type="1" className="indent">
                            <li><p>
                                Budget &amp; Finance
                            </p></li>
                            <li><p>
                                Building Maintenance
                            </p></li>
                            <li><p>
                                PCCM Fund
                            </p></li>
                            <li><p>
                                Membership
                            </p></li>
                            <li><p>
                                Programs &amp; Services
                            </p></li>
                            <li><p>
                                Nomination &amp; Election
                            </p></li>
                            <li><p>
                                Volunteer &amp; Awards
                            </p></li>
                            <li><p>
                                Policy &amp; Procedures
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Adhoc Committees – </b>Adhoc Committees shall address a special and usually short term need
                            and are disbanded when the purpose has been fulfilled and will comprise of the following:
                        </p></li>
                        <ol type="1" className="indent">
                            <li><p>
                                Constitution &amp; By-Laws
                            </p></li>
                            <li><p>
                                Naming Rights
                            </p></li>
                            <li><p>
                                Special Events
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            The Standing and Adhoc Committees are mandated to aid PCCM in accomplishing its goals
                            until a subsequent official actions by a majority of the Governing Board disbands their
                            existence.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>7.2 Committee Composition</h5>
                    <p>
                        Each of these committees shall consist of:
                    </p>
                    <ol type="1">
                        <li><p>
                            A chairperson appointed through the President’s recommendation and approval by a
                            majority vote of the Governing Board.
                        </p></li>
                        <li><p>
                            A member of the Filipino community who upholds the ideals &amp; goals of PCCM.
                        </p></li>
                        <li><p>
                            Two card-carrying Regular Members of PCCM.
                        </p></li>
                        <li><p>
                            A card-carrying Student Member of PCCM.
                        </p></li>
                        <li><p>
                            An authorized representative from an Affiliate Member.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>7.3 Committee Procedure</h5>
                    <p>
                        Each committee shall meet at the call of the Chair, keep minutes of its meetings, and submit a
                        complete report of all decisions and actions taken by it since the last meeting of the Governing
                        Board.
                    </p>
                </div>
            </div>
        </>
    );
}

export default ArticleSeven;